function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".picklist-pos__align", shadowSelector, " {padding: 8px 0 5px 0;}"].join('');
}
export default [stylesheet];